import type { TempWorkSession } from '@/modules/temp-worker/services/tempWorker'

export function isTempWorkSessionEditable(
  session: TempWorkSession,
  paidThroughWorkDate?: string | null,
): boolean {
  if (session.check_out_at == null) return false
  if (!paidThroughWorkDate) return true
  return session.work_date > paidThroughWorkDate
}
